import { motion } from "framer-motion";
import { Seo } from "@/components/Seo";
import { EnquiryForm } from "@/components/EnquiryForm";
import { IMAGES } from "@/data/products";

const fade = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-60px" },
  transition: { duration: 0.6, ease: "easeOut" },
};

export default function IndianWholesale() {
  return (
    <div data-testid="wholesale-page">
      <Seo
        title="Indian Wholesale Denim Supply — Shineni India, Faridabad"
        description="Factory-direct wholesale denim jeans supply across India for wholesalers, distributors and retail chains. Send your wholesale enquiry to Shineni India."
      />

      <section className="border-b border-border bg-white">
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-20">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-gold">Within India</p>
          <h1 className="mt-3 max-w-3xl font-display text-4xl font-semibold text-indigo sm:text-5xl">
            Wholesale denim, direct from the factory
          </h1>
          <p className="mt-4 max-w-2xl text-base text-foreground/70">
            For wholesalers, distributors and retail chains across India. You buy from the
            manufacturer in Faridabad — direct pricing, one point of contact, and production
            matched to your program.
          </p>
        </div>
      </section>

      <section className="mx-auto grid max-w-7xl gap-12 px-4 py-16 sm:px-6 lg:grid-cols-5">
        <motion.div {...fade} className="lg:col-span-2">
          <img src={IMAGES.folded} alt="Folded denim jeans stacked for wholesale dispatch — sample imagery" className="aspect-[4/3] w-full rounded-sm border border-border object-cover" />
          <p className="mt-2 text-xs text-muted-foreground">Representative sample imagery</p>
          <div className="mt-8 space-y-6">
            <div className="border-l-2 border-gold pl-5">
              <h2 className="font-display text-lg font-semibold text-indigo">Factory-direct terms</h2>
              <p className="mt-1 text-sm text-foreground/70">Pricing quoted per program after reviewing your ranges and quantities. No published price lists, no hidden layers.</p>
            </div>
            <div className="border-l-2 border-gold pl-5">
              <h2 className="font-display text-lg font-semibold text-indigo">Ranges for your market</h2>
              <p className="mt-1 text-sm text-foreground/70">Women's, men's and kids' jeans produced to your fits, washes and size sets.</p>
            </div>
            <div className="border-l-2 border-gold pl-5">
              <h2 className="font-display text-lg font-semibold text-indigo">Your label or ours</h2>
              <p className="mt-1 text-sm text-foreground/70">Stock programs or private-label production with your branding and packaging.</p>
            </div>
          </div>
        </motion.div>
        <motion.div {...fade} className="lg:col-span-3">
          <EnquiryForm
            variant="domestic"
            title="Wholesale enquiry"
            subtitle="Tell us what you need — our team responds on email or WhatsApp."
          />
        </motion.div>
      </section>
    </div>
  );
}
